import { render, staticRenderFns } from "./tabChange.vue?vue&type=template&id=678945df"
import script from "./tabChange.vue?vue&type=script&lang=ts"
export * from "./tabChange.vue?vue&type=script&lang=ts"
import style0 from "./tabChange.vue?vue&type=style&index=0&id=678945df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-co_fdc8552a8ede636d403bf9928f1c7af2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports